import { SVGProps } from 'react';

export function HumanScaredFace(props: SVGProps<SVGSVGElement>) {
  return (
    <svg id="emoji" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg" data-testid="human-scared-face" {...props}>
      <g id="color">
        <circle cx="36" cy="36" r="23" fill="#FCEA2B" />
        <path
          fill="#FFFFFF"
          d="M43.1797,51.8701H28.8106c0-4,2.3896-7.1796,7.1797-7.1796c4.789,0,7.2099,3.1894,7.2099,7.1796"
        />
      </g>
      <g id="hair" />
      <g id="skin" />
      <g id="skin-shadow" />
      <g id="line">
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M43.1797,51.8701H28.8106c0-4,2.3896-7.1796,7.1797-7.1796c4.789,0,7.2099,3.1894,7.2099,7.1796"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M20.2793,27.2002c0.7207-1.3857,1.9278-2.4541,3.3907-3c1.4052-0.7002,3.0205-0.8486,4.5302-0.4209"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M50.8897,27.2002c-1.582-2.7724-4.8037-4.1699-7.9092-3.4306"
        />
        <circle
          cx="36"
          cy="36"
          r="23"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        />
        <path d="M30,34c0,1.6568-1.3448,3-3,3c-1.6553,0-3-1.3433-3-3c0-1.6552,1.3447-3,3-3C28.6552,31,30,32.3448,30,34" />
        <path d="M48,34c0,1.6568-1.3447,3-3,3s-3-1.3433-3-3c0-1.6552,1.3447-3,3-3S48,32.3448,48,34" />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M20.6948,27.2002c0.7207-1.3857,1.9278-2.4541,3.3907-3c1.4052-0.7002,3.0205-0.8486,4.5302-0.4209"
        />
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          d="M51.3052,27.2002c-1.582-2.7724-4.8037-4.1699-7.9092-3.4306"
        />
      </g>
    </svg>
  );
}
